"use strict";
/* eslint-disable camelcase */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssignedCollateralAccountsCount = exports.getCollateralAccountsEffectiveAdvanceRate = exports.getCollateralAccountsTotalMarketValue = exports.generateCollateralAccountsForLoanAccount = exports.generateCollateralAccounts = void 0;
const generateReceivableStats_1 = require("./generateReceivableStats");
const receivableResponseTapeUtils = __importStar(require("./receivableResponseTape"));
const getCollateralAccountProductName = (receivables) => {
    var _a, _b;
    return (_b = (_a = receivables[0]) === null || _a === void 0 ? void 0 : _a.receivableReponseTapeRow.baseFields.product_name) !== null && _b !== void 0 ? _b : '';
};
/**
 * Needs full list of receivables to calculate collateral account stats
 * But for CA for `Loan Account`, we need to only return line item `receivables` that are
 * assigned to the `loan Account` to correctly display holdings
 */
const generateCollateralAccount = ({ accountNumber, receivables, collateralAccountCustomers, }) => {
    var _a, _b;
    const cifNum = (_a = receivables[0]) === null || _a === void 0 ? void 0 : _a.cif_num;
    const owner = (_b = collateralAccountCustomers.find((collateralAccountCustomer) => collateralAccountCustomer.cif_num === cifNum)) !== null && _b !== void 0 ? _b : null;
    const stats = (0, generateReceivableStats_1.generateReceivableStats)(receivables);
    return {
        accountNumber,
        cifNum,
        owner,
        marketValue: stats.totalMarketValue,
        productName: getCollateralAccountProductName(receivables),
        // applicable to only assigned receivables on a collateral account from the perspective of a loan account, otherwise it's always 100%
        effectiveAllocation: 1,
        // applicable to only assigned receivables on a collateral account from the perspective of a loan account, since everything is "allocated" to a collateral account, the post allocation market value is the same as the total market value
        preAllocationLendableValue: stats.totalPreAllocationLendableValue,
        effectiveAdvanceRate: stats.effectiveAdvanceRate,
        postAllocationLendableValue: stats.totalPostAllocationLendableValue,
        receivables,
    };
};
const generateCollateralAccountForLoanAccount = ({ accountNumber, allCollateralAccountReceivables, loanAccountNumber, collateralAccountCustomers, }) => {
    var _a, _b;
    const cifNum = (_a = allCollateralAccountReceivables[0]) === null || _a === void 0 ? void 0 : _a.cif_num;
    const owner = (_b = collateralAccountCustomers.find((collateralAccountCustomer) => collateralAccountCustomer.cif_num === cifNum)) !== null && _b !== void 0 ? _b : null;
    const assignedReceivables = allCollateralAccountReceivables.filter(({ loan_account_number }) => loan_account_number === loanAccountNumber);
    // what is the market value of all collateral.
    const allCollatStats = (0, generateReceivableStats_1.generateReceivableStats)(allCollateralAccountReceivables);
    const assignedCollatStats = (0, generateReceivableStats_1.generateReceivableStats)(assignedReceivables);
    return {
        accountNumber,
        cifNum,
        owner,
        productName: getCollateralAccountProductName(assignedReceivables),
        // will always receive all receivalbes for collateral account, so need to make sure market value is not multiple counted
        marketValue: allCollatStats.totalMarketValue,
        effectiveAllocation: assignedCollatStats.effectiveAllocationRate,
        preAllocationLendableValue: assignedCollatStats.totalPreAllocationLendableValue,
        effectiveAdvanceRate: assignedCollatStats.effectiveAdvanceRate,
        receivables: assignedReceivables,
        postAllocationLendableValue: assignedCollatStats.totalPostAllocationLendableValue,
    };
};
const generateCollateralAccounts = ({ receivables, collateralAccountCustomers, }) => {
    const groupedReceivables = receivableResponseTapeUtils.groupReceivableResponseTape({
        groupBy: 'collateral_account_number',
        receivables,
    });
    return Object.entries(groupedReceivables).map(([accountNumber, _receivables]) => generateCollateralAccount({
        accountNumber,
        receivables: _receivables,
        collateralAccountCustomers,
    }));
};
exports.generateCollateralAccounts = generateCollateralAccounts;
const generateCollateralAccountsForLoanAccount = ({ receivables, loanAccountNumber, collateralAccountCustomers, }) => {
    const groupedReceivables = receivableResponseTapeUtils.groupReceivableResponseTape({
        groupBy: 'collateral_account_number',
        receivables,
    });
    return Object.entries(groupedReceivables).map(([accountNumber, _receivables]) => generateCollateralAccountForLoanAccount({
        accountNumber,
        allCollateralAccountReceivables: _receivables,
        loanAccountNumber,
        collateralAccountCustomers,
    }));
};
exports.generateCollateralAccountsForLoanAccount = generateCollateralAccountsForLoanAccount;
const getCollateralAccountsTotalMarketValue = (collateral) => {
    return collateral.reduce((acc, c) => acc + c.marketValue, 0);
};
exports.getCollateralAccountsTotalMarketValue = getCollateralAccountsTotalMarketValue;
const getCollateralAccountsEffectiveAdvanceRate = (collateral) => {
    const { effectiveAdvanceRate } = (0, generateReceivableStats_1.generateReceivableStats)(collateral.flatMap((col) => col.receivables));
    return effectiveAdvanceRate;
};
exports.getCollateralAccountsEffectiveAdvanceRate = getCollateralAccountsEffectiveAdvanceRate;
/**
 * Returns the number of assigned collateral accounts within a list of collateral accounts
 *
 * If any receivable in the collateral account has a loan account number, then the collateral account is considered assigned
 */
const getAssignedCollateralAccountsCount = (collateralAccounts) => {
    let assignedAccounts = 0;
    for (const account of collateralAccounts) {
        if (account.receivables.some((receivable) => receivable.loan_account_number)) {
            assignedAccounts += 1;
        }
    }
    return assignedAccounts;
};
exports.getAssignedCollateralAccountsCount = getAssignedCollateralAccountsCount;
//# sourceMappingURL=collateralAccounts.js.map